export default {
  title: 'E-Payslip',
  home: 'Home',
  company: 'Company',
  form: {
    guided: {
      documents: 'Documents and display names',
      access: 'Expiry and access',
      displayName: 'Display name',
      noExpiry: '0 = No expiry'
    },
    'pay-slip': 'Pay Slip',
    tawi: '50 TAWI',
    pnd: 'PND 91',
    other: 'TAB 4',
    'forgot-password': 'Forgot Password ePay slip button',
    'custom-placeholder': 'Custom Name',
    'expiry-days': 'Expiry Days (0 = No Expiry)'
  },
  'company-table': require('./CompanyTable.js').default
}
